<template>
  <div class="base-section-title">
    <div class="title-content flex col-center">
      <div class="title-tag"></div>
      <div class="m-l-6">
        <slot>{{ title }}</slot>
      </div>
    </div>

    <div class="right-tool">
      <slot name="right-tool"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSectionTitle',

  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.base-section-title {
  position: relative;

  .title-content {
    color: $text-color;
    font-size: 16px;
    position: relative;

    .title-tag {
      width: 4px;
      height: 16px;
      background-color: $primary-color;
    }
  }

  .right-tool {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
  }
}
</style>
